import React from 'react'

export const WatchLaterIcon = (color = '#0A7DE6', width = 12, height = 12) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.10938 7.10938L7.50781 6.45312L5.25781 5.09375V2.49219H4.50781V5.49219L7.10938 7.10938ZM1.46094 1.48438C2.44531 0.5 3.625 0.0078125 5 0.0078125C6.375 0.0078125 7.54688 0.5 8.51562 1.48438C9.5 2.45312 9.99219 3.625 9.99219 5C9.99219 6.375 9.5 7.55469 8.51562 8.53906C7.54688 9.50781 6.375 9.99219 5 9.99219C3.625 9.99219 2.44531 9.50781 1.46094 8.53906C0.492188 7.55469 0.0078125 6.375 0.0078125 5C0.0078125 3.625 0.492188 2.45312 1.46094 1.48438Z"
        fill={color}
      />
    </svg>
  )
}
